import { useMemo } from "react";

import { IntlShape } from "react-intl";

import ActivityStatusOption from "@mapmycustomers/shared/enum/activity/ActivityStatusOption";

import RecapRange, { getRecapRangeDisplayName } from "@app/enum/preview/RecapRange";

const useRecapRangeOptions = (intl: IntlShape, appliedFilter: ActivityStatusOption) =>
  useMemo(
    () =>
      [
        RecapRange.THIS_WEEK,
        RecapRange.LAST_WEEK,
        RecapRange.NEXT_WEEK,
        RecapRange.THIS_MONTH,
        RecapRange.LAST_MONTH,
        RecapRange.NEXT_MONTH,
        RecapRange.THIS_QUARTER,
        RecapRange.LAST_QUARTER,
        RecapRange.NEXT_QUARTER,
        RecapRange.THIS_YEAR,
        RecapRange.LAST_YEAR,
        RecapRange.ALL_TIME,
      ].map((range) => ({
        disabled:
          (appliedFilter === ActivityStatusOption.OVERDUE &&
            (range === RecapRange.NEXT_WEEK ||
              range === RecapRange.NEXT_MONTH ||
              range === RecapRange.NEXT_QUARTER)) ||
          (appliedFilter === ActivityStatusOption.UPCOMING &&
            (range === RecapRange.LAST_WEEK ||
              range === RecapRange.LAST_MONTH ||
              range === RecapRange.LAST_QUARTER ||
              range === RecapRange.LAST_YEAR)),
        label: getRecapRangeDisplayName(intl, range),
        value: range,
      })),
    [intl, appliedFilter]
  );

export default useRecapRangeOptions;
